import { render, staticRenderFns } from "./AttachmentsList.vue?vue&type=template&id=2d36975e&scoped=true&"
import script from "./AttachmentsList.vue?vue&type=script&lang=js&"
export * from "./AttachmentsList.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsList.vue?vue&type=style&index=0&id=2d36975e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36975e",
  null
  
)

export default component.exports